import { useSelector } from 'react-redux';
import { INTERNATIONAL_SUPPORT } from '@rsos/capstone/src/constants/capabilities';
import { formatPhoneWithDashes } from '@rsos/utils';

const useDisplayPhoneNumber = callerID => {
  const formattedPhone = formatPhoneWithDashes(callerID);

  const isInternational = useSelector(
    state =>
      !!(
        state.psaps.currentPSAP.activeCapabilities &&
        state.psaps.currentPSAP.activeCapabilities[INTERNATIONAL_SUPPORT]
      ),
  );

  const displayPhoneNumber = isInternational ? callerID : formattedPhone;

  return displayPhoneNumber;
};

export default useDisplayPhoneNumber;
